import React from "react";
import {Radio, FormGroup} from "react-bootstrap";
import {PaymentPlans, PaymentTypes, URLs} from "../../common/constants";
import {formatMoney} from "../../common/basket";
import {translate} from "../../i18n/translate.js";
import {getPageContext} from "../../common/utils";

class PaymentPlansSelection extends React.Component {
    static defaultProps = {
        customAmount: ""
    };

    handleSelected = (plan) => {
        this.props.setPaymentPlan(plan);
    };

    handleChangeAmount = (plan, event) => {
        let amount = event.target.value;
        if(!(/^\d+(?:[.]\d*?)?$/).test(amount) && amount !== "") {
            return;
        }
        if (amount === '')
            amount = 0;
        this.props.setCustomAmount(amount);
        amount = parseFloat(amount);
        if(isNaN(amount)) {
            return;
        }
        this.handleSelected(Object.assign({}, plan, {amount}));
    };

    getAmount = (plan) => {
        if (plan.type === PaymentPlans.DynamicPrePayment || plan.type === PaymentPlans.DistributionDynamicPrePayment)
            return plan.totalToPay;
        return plan.amount;
    };

    getPlan = (plan) => {
        const selected = this.props.paymentPlan ? plan.key === this.props.paymentPlan.key : false;
        if (plan.isPayMyDebit && this.props.balance < -0.1) {
            plan.amount = this.props.balance*-1;
        }
        const amount = this.getAmount(plan);
        if(plan.type === PaymentPlans.CustomPrePayment && plan.isPayMyDebit && this.props.balance > -0.1) {
            return null;
        }
        return (
            <Radio name="methodPlan" checked={selected} key={plan.key} onChange={this.handleSelected.bind(this, plan)}>
                {
                    plan.type === PaymentPlans.CustomPrePayment && !plan.isPayMyDebit ?
                        <div>
                            <input type="text" className="payment-amount-input" placeholder="Enter Amount"
                                   onChange={this.handleChangeAmount.bind(this, plan)}
                                   value={this.props.customAmount === 0 ? "" : this.props.customAmount}/>
                            <div className="payment-amount-description"
                                 dangerouslySetInnerHTML={{__html: plan.note}}/>
                        </div> :
                        <div>
                            <b name="paymentAmount">{(this.props.paymentType === PaymentTypes.PAYMENT_PLAN.type || plan.type === PaymentPlans.OneWeekDebit || plan.key === 'none') ?
                                plan.title : formatMoney(amount)}</b>
                            <div className="payment-amount-description"
                                 dangerouslySetInnerHTML={{__html: plan.note}}>{}</div>
                        </div>
                }
            </Radio>);
    };

    getPlans = () => {
        const plans = [];
        for(let key in this.props.paymentPlans) {
            if(this.props.paymentPlans.hasOwnProperty(key)) {
                const plan = this.props.paymentPlans[key];
                if (plan.type === PaymentPlans.CustomPrePayment) {
                    plans.unshift(this.getPlan(plan));
                } else {
                    plans.push(this.getPlan(plan));
                }
            }
        }
        const isAdminPayments = getPageContext() === URLs.CHARGE;
        if (this.props.allowNone) {
            plans.push(this.getPlan({key: 'none', title: 'Cancel', note: isAdminPayments ? 'Remove payment plan' : 'Cancel automatic charges'}));
        }
        return plans;
    };

    render() {
        if (this.props.paymentType === PaymentTypes.PAYMENT_TOKEN.type || this.props.paymentType === PaymentTypes.UPDATE_PAYMENT.type)
            return null;
        const title = this.props.paymentType === PaymentTypes.CHARGE.type ? "Enter Charge Amount" :
            this.props.paymentType === PaymentTypes.PAYMENT_PLAN.type ? "Select Payment Plan" :
                "Select Payment Amount";

        return(
            <FormGroup>
                <h4>{translate(title)}</h4>
                {this.getPlans()}
            </FormGroup>);
    }
}

export default PaymentPlansSelection;



// WEBPACK FOOTER //
// ./src/components/pay/PaymentPlansSelection.js